"use client";

import Script from "next/script";

import { NODE_ENV } from "@workspace/shared/constants";

import { env } from "../../env.config";

export const onLemonLoad = () => {
  if ("createLemonSqueezy" in window) {
    // @ts-expect-error lemonsqueezy is not typed
    window.createLemonSqueezy();
  }
};

export const LemonSqueezyScript = () => (
  <>
    <Script id="lemon-affiliate-config" strategy="afterInteractive">
      {`window.lemonSqueezyAffiliateConfig = { store: "turbostarter"${
        env.NODE_ENV === NODE_ENV.DEVELOPMENT ? ", debug: true" : ""
      } };`}
    </Script>
    <Script
      src="https://lmsqueezy.com/affiliate.js"
      strategy="afterInteractive"
    />
    <Script
      src="https://app.lemonsqueezy.com/js/lemon.js"
      strategy="afterInteractive"
      onLoad={onLemonLoad}
    />
  </>
);
